import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import config from "../../config";

// ----------------------------------------------------------------------

export default function Sidebar({isAllView}) {
  const [priceData, setPriceData] = useState([]);
  const callTodayMain = async () => {
    axios({
      url: config.API_URL + "/comm/selMvalue",
      method: "post",
      data: {},
      headers: {
        ...axios.defaults.headers,
        Authorization: "",
      },
    }).then((res) => {
      const data = res?.data?.resultList;
      // console.log('시세 데이터 >>> ', data);
      // const temp = data[3];
      // for (let i = 3; i > 0; i--) {
      //   data[i] = data[i - 1];
      // }
      // data[0] = temp;
      setPriceData(data);
    });
  };

  useEffect(() => {
    callTodayMain();
  }, []);

  return (
    <div className="pc_view">
      <S.Box2>
        <S.Content_div>
          <S.CenterMain>
            <S.ParaHead>고객센터</S.ParaHead>            
            <S.ParaTel>010·4478·8944</S.ParaTel>
            <S.Para>
              평일 09:00~18:00
              <br />
              토/일/공휴일 휴무
            </S.Para>
          </S.CenterMain>
        </S.Content_div> 
        {isAllView && (
          <S.Content_div>
            <S.ContentHead>거래 시세</S.ContentHead>
            <S.ContentMain>
              <div className="side-banner">
                {priceData?.length > 0 &&
                  priceData?.map((item, index) => {
                    if (item?.car_weight_cd === 2303 || item?.car_weight_cd === 2304) return;
                    return (
                      <div key={index}>
                        <div className="side-body">
                          <label>
                            {/* {item?.deal_category_cd === 2101 && "개인"} */}
                            {/* {item?.deal_category_cd === 2102 && "법인매매"}
                            {item?.deal_category_cd === 2103 && "법인임대"} */}
                            {item?.deal_category_cd === 2101 && item?.car_weight_cd === 2301 && "개인용달"}
                            {item?.deal_category_cd === 2101 && item?.car_weight_cd === 2302 && "개인개별"}
                            {item?.deal_category_cd === 2104 && "주선면허"}
                            {/* {item?.car_weight_cd === 2303 && "개인대형"} */}
                            {/* {item?.car_weight_cd === 2304 && "전기차 소형"} */}
                          </label>
                        </div>
                        <div className="price">
                          <span
                            className={`${
                              (item?.deal_category_cd === 2101 &&
                                item?.car_weight_cd === 2301 &&
                                "lbl-orange") ||
                              (item?.deal_category_cd === 2101 &&
                                item?.car_weight_cd === 2302 &&
                                "lbl-green") ||
                              // (item?.deal_category_cd === 2101 &&
                              //   item?.car_weight_cd === 2303 &&
                              //   "lbl-blue") ||
                              // (item?.deal_category_cd === 2101 &&
                              //   item?.car_weight_cd === 2304 &&
                              //   "lbl-red") ||
                              (item?.deal_category_cd === 2104 && "lbl-purple")
                            } amount`}
                          >
                            {item?.avg_price
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                          <span className="unit">&nbsp;만원</span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </S.ContentMain>
            <S.BackgroundBox />
          </S.Content_div>
        )}         
      </S.Box2>
    </div>
  );
}

// ----------------------------------------------------------------------

const S = {
  // Box: styled.div`
  //   width: 150px;
  //   height: 225px;
  //   border-radius: 20px;
  //   position: fixed;
  //   right: 0px;
  //   bottom: 300px;
  //   z-index: 1000;
  //   @media screen and (max-width: 1170px) {
  //     img {
  //       width: 100%;
  //     }
  //     right: -30px;
  //     bottom: 250px;
  //   }
  // `,
  Box2: styled.div`
    width: 148px;
    height: 148px;
    // height: 550px;
    // background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3); /* 그림자 */
    border-radius: 19px;
    
    background: linear-gradient(to bottom, #62686d 0%, #62686d 33%, white 33%, white 100%);
    font-weight: bold;    
    
    position: fixed;
    right: 10px;
    // top: 15.5vh;
    top: 130px;
    z-index: 1000;

    // border-radius: 17px;
    // left: 90%;
    // bottom: 300px;
    // background-image: url(${process.env.PUBLIC_URL}/img/banner_right.png);
    // background: #fff;
    // filter: drop-shadow(0px 4px 9px rgba(0, 0, 0, 0.1));

    @media screen and (max-width: 1400px) {
      display: none;
    }
  `,
  
  Content_div: styled.div`
    padding: 13px 10px;
    position: relative;
  `,

  BackgroundBox : styled.div`
    // width: 138px;
    // background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3); /* 그림자 */
    border-radius: 19px;
    
    position: absolute;
    top: 10px;
    left: 50%; 
    transform: translateX(-50%);
    z-index: 0; /* 배경이 되도록 */
    
    // width: 156px;
    height: 315px;
    // background-image: url(${process.env.PUBLIC_URL}/img/banner_right.png);

    width: 148px;
    // height: 426px;
    background: linear-gradient(to bottom, #62686d 0%, #62686d 14%, white 14%, white 100%);
  `,

  ContentHead: styled.div`
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 8px;

    position: relative;
    z-index: 1;
    @media screen and (max-width: 1170px) {
      font-size: 16px;
    }
  `,
  ContentMain: styled.div`
    // color: #ff7200;
    text-align: center;
    font-size: 17px;
    font-style: normal;
    // font-weight: 600;
    line-height: normal;
    padding-top: 15px;    

    position: relative;
    z-index: 1;
    @media screen and (max-width: 1170px) {
      font-size: 16px;
    }
  `,
  CenterMain: styled.div`
    position: relative;
    z-index: 1; /* 실제 내용이 배경 위에 오도록 */
  `,
  ParaHead: styled.p`
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 20px;
    @media screen and (max-width: 1170px) {
      font-size: 12px;
    }
  `,
  ParaTel: styled.p`
    color: #4486ff;
    text-align: center;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-top: 11px;
    margin-bottom: 9px;
    @media screen and (max-width: 1170px) {
      font-size: 12px;
      margin-top: 11px;
      margin-bottom: 4px;
    }
  `,
  Para: styled.p`
    color: #919191;
    text-align: center;
    font-size: 13.5px;
    font-style: normal;
    line-height: normal;
    margin-bottom: 0px;
    @media screen and (max-width: 1170px) {
      font-size: 11px;
    }
  `,
};
